<template>
  <svg width="100" height="60" viewBox="0 0 100 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- Coin -->
    <g>
      <circle cx="50" cy="30" r="20" fill="#FFD700" stroke="black" stroke-width="2"/>
      <text x="42" y="35" font-size="16" font-weight="bold" fill="black">$</text>

      <!-- Rotation Animation -->
      <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 50 30"
          to="360 50 30"
          dur="1.5s"
          repeatCount="indefinite"
      />
    </g>
  </svg>
</template>
